/**
 * Time formatting utilities for converting minutes to Croatian format
 */

/**
 * Converts minutes to Croatian time format
 * @param minutes Total minutes as number
 * @returns Formatted string like "1 sat i 15 minuta" or "45 minuta" or "2 sata"
 */
export function formatMinutesToCroatian(minutes: number | string): string {
    const totalMinutes = typeof minutes === 'string' ? parseInt(minutes, 10) : minutes;
    
    if (isNaN(totalMinutes) || totalMinutes < 0) {
        return '';
    }

    const hours = Math.floor(totalMinutes / 60);
    const remainingMinutes = totalMinutes % 60;

    if (hours === 0) {
        // Only minutes
        return remainingMinutes === 1 ? "1 minuta" : `${remainingMinutes} minuta`;
    } else if (remainingMinutes === 0) {
        // Only hours
        if (hours === 1) {
            return "1 sat";
        } else if (hours >= 2 && hours <= 4) {
            return `${hours} sata`;
        } else {
            return `${hours} sati`;
        }
    } else {
        // Hours and minutes
        const hoursPart = hours === 1 ? "1 sat" : 
                         hours >= 2 && hours <= 4 ? `${hours} sata` : 
                         `${hours} sati`;
        const minutesPart = remainingMinutes === 1 ? "1 minuta" : `${remainingMinutes} minuta`;
        
        return `${hoursPart} i ${minutesPart}`;
    }
}


// WEBPACK FOOTER //
// ./src/utils/timeFormatter.ts